<script>
    import DetailTabs from "./detail-tabs/DetailTabs.svelte";
    import TabsPreview from "./tabs-preview/TabsPreview.svelte";
    import {projectDetailStore} from "../../../../stores/projectStore";
    import {tokenDetailStore} from "../../../../stores/tokenStore";

    let tabsSteps = 1, projectDetails, tokenDetails;

    const setTabsSteps = (newStep) => {
        tabsSteps = newStep
    }

    projectDetailStore.subscribe((value) => {
        projectDetails = value;
    })

    tokenDetailStore.subscribe((value) => {
        tokenDetails = value;
    })

</script>

<div class="pl-preview-detail">
    <DetailTabs setTabsSteps={setTabsSteps} tabsSteps={tabsSteps} {projectDetails} {tokenDetails}/>
    {#if tabsSteps === 1}
        <TabsPreview source={projectDetails.story} />
    {:else if tabsSteps === 2}
        <TabsPreview source={tokenDetails.tokenDetails} />
    {:else if tabsSteps === 3}
        <TabsPreview source={projectDetails.rewards} rewardDistributionDate={projectDetails.rewardDistributionDate}/>
    {/if}
</div>